import { render, staticRenderFns } from "./WheelBattleScoreTab.vue?vue&type=template&id=6d929858&scoped=true&"
import script from "./WheelBattleScoreTab.vue?vue&type=script&lang=js&"
export * from "./WheelBattleScoreTab.vue?vue&type=script&lang=js&"
import style0 from "./WheelBattleScoreTab.vue?vue&type=style&index=0&id=6d929858&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d929858",
  null
  
)

export default component.exports